import { DatasetObjectQueryColumn } from '@warebee/frontend/data-access-api-graphql';
import { FormattedValueWithUnit } from '../../common/formatHelper';
import { Formatter } from '../../common/useFormatter';
import { CustomRenderedColumnType } from './aiAgent.types';

export function getColumnRenderType(
  column: DatasetObjectQueryColumn,
): CustomRenderedColumnType {
  if (!column || !column.name) return 'text';

  const name = column.name.toLowerCase();
  if (
    name.includes('agent') &&
    !name.includes('type') &&
    column.type === 'varchar'
  )
    return 'agentId';
  if (name.includes('job_id')) return 'job';
  if (name.includes('event_id')) return 'event';
  if (name.includes('sku') || name === 'item') return 'item';
  if (
    name === 'location' ||
    name === 'loc' ||
    name === 'locationid' ||
    name === 'location id'
  )
    return 'location';
  if (
    name.includes('velocity') ||
    name.includes('category') ||
    name.includes('percentrank') ||
    name.includes('abc') ||
    name.includes('metric') ||
    name.includes('rank') ||
    name.includes('location zone') ||
    name.includes('xyz')
  )
    return 'velocity';

  if (name.includes('percent') || name === '%' || name.includes('percentage'))
    return 'percent';
  if (name.includes('weight')) return 'weight';
  if (name.includes('volume')) return 'volume';
  if (name.includes('distance')) return 'distance';
  if (name.includes('compliance')) return 'compliance';
  if (name.includes('cost') || name.includes('price') || name.includes('value'))
    return 'currency';
  if (
    name.includes('duration') ||
    (name.includes('time') && column.type === 'number')
  )
    return 'duration';

  // Detect by value pattern/type
  if (
    name.includes('qty') ||
    name.includes('quantity') ||
    name.includes('amount') ||
    name.includes('count') ||
    name.includes('visit') ||
    name.includes('total')
  )
    return 'quantity';

  if (column.type === 'timestamp') return 'localDateTime';

  return 'text';
}

export function getColumnDataFormatter(
  column: DatasetObjectQueryColumn,
  formatter: Formatter,
): (v: number, cutOf?: number) => FormattedValueWithUnit {
  if (!column) {
    return (value: number) => formatter.formatNumber(value);
  }

  const typedRender = getColumnRenderType(column);

  switch (typedRender) {
    case 'weight':
      return (value: number) => formatter.formatWeight(value);

    case 'volume':
      return (value: number) => formatter.formatVolume(value);

    case 'quantity':
      return (value: number) => formatter.formatInteger(value);

    case 'percent':
      return (value: number) => formatter.formatShare(value / 100);

    case 'currency':
      return (value: number) => formatter.formatCurrency(value, 2);

    case 'distance':
      return (value: number) => formatter.formatDistance(value, 2);

    case 'duration':
      return (value: number) => formatter.formatTimeSpan(value, 2);
  }
  if (
    column.type === 'double' ||
    column.type === 'bigint' ||
    column.type === 'integer'
  ) {
    return formatter.formatNumber;
  }
  return null;
}
